<template>
  <div v-if="modalOpen">
    <q-dialog v-model="modalOpen" persistent class="forgot-password-modal">
      <q-card style="min-width: 650px">
        <q-card-section class="card-section">
          <div class="text-h6">Forgot Password</div>
        </q-card-section>

        <q-card-section class="q-pt-none card-content">
          <q-input
            square
            autofocus
            outlined
            label-color="white"
            outline-color="white"
            label="Username"
            :input-style="{ color: 'white' }"
            color="white"
            @update:model-value="(e) => updateForgotPasswordData({ field: 'UserName', value: e})"
            :model-value="username"
            @blur="touch('username')"
            :error="v$.username.$error"
            :error-message="validation.username.message"
          />
          <q-input
            square
            autofocus
            outlined
            label-color="white"
            outline-color="white"
            label="Email Address"
            :input-style="{ color: 'white' }"
            color="white"
            @update:model-value="(e) => updateForgotPasswordData({ field: 'UserEmail', value: e})"
            :model-value="email"
            @blur="touch('email')"
            :error="v$.email.$error"
            :error-message="validation.email.message"
          />
          <q-input
            square
            autofocus
            outlined
            label-color="white"
            outline-color="white"
            label="Pin Code"
            :input-style="{ color: 'white' }"
            color="white"
            type="password"
            @update:model-value="(e) => updateForgotPasswordData({ field: 'UserPass2', value: e})"
            :model-value="pinCode"
            :rules="[ val => val ? val.length <= 6 : '' || 'Please use maximum 6 Numbers']"
            @blur="touch('pinCode')"
            :error="v$.pinCode.$error"
            :error-message="validation.pinCode.message"
          />
          <q-btn label="Submit" class="forgot-password-action" @click="submit"/>
          <q-btn color="black" label="Close" v-close-popup/>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import { useVuelidate } from '@vuelidate/core'
import { required, maxLength, minLength, email, numeric } from "vuelidate/lib/validators";

export default {
  setup () {
    return { v$: useVuelidate() }
  },
  name: 'ForgotPasswordModal',
  props: {
    open: {
      required: true,
      type: Boolean
    }
  },
  watch: {
    open (val) {
      this.modalOpen = val
      if(val) {
        this.v$.$reset()
        this.setupCaptcha()
      }
    },
    modalOpen (val) {
      if (!val) {
        this.clearForgotPasswordData()
        this.$emit('close')
      }
    }
  },
  data () {
    return {
      modalOpen: false,
      validation: {
        username: {
          error: false,
          message: ''
        },
        pinCode: {
          error: false,
          message: ''
        },
        email: {
          error: false,
          message: ''
        }
      }
    }
  },
  computed: {
    ...mapState({
      username: (state) => state.forgotPassword.UserName,
      pinCode: (state) => state.forgotPassword.UserPass2,
      email: (state) => state.forgotPassword.UserEmail,
      token: (state) => state.forgotPassword.token
    })
  }, 
  validations: {
    username: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(20)
    },
    pinCode: {
      required,
      numeric,
      minLength: minLength(6),
      maxLength: maxLength(6),
    },
    email: {
      required,
      email
    }
  },
  methods: {
    ...mapActions({
      updateForgotPasswordData: 'forgotPassword/updateForgotPasswordData',
      clearForgotPasswordData: 'forgotPassword/clearForgotPassowrdData',
      requestForgotPassword: 'forgotPassword/requestForgotPassword'
    }),
    async setupCaptcha () {
      await this.$recaptchaLoaded()

      const token = await this.$recaptcha('forgotpassword')

      this.updateForgotPasswordData({ field: 'token', value: token })
    },
    touch (field) {
      this.v$[field].$touch()
      this.getErrorMesage()
    },
    async submit () {
      this.v$.$touch()

      if (this.v$.$invalid) {
        this.getErrorMesage()
        return
      }

      this.$q.loading.show()
      await this.requestForgotPassword()
        .then((response) => {
          this.$q.notify({
            progress: true,
            position: 'center',
            multiLine: true,
            message: response.data.message,
            type: 'positive',
            timeout: 10000
          })
          this.$q.loading.hide()
          this.modalOpen = false
        })
        .catch((e) => {
          this.$q.notify({
            position: 'top-right',
            message: e.response.data.message,
            type: 'negative',
          })
          this.$q.loading.hide()
        })
    },
    getErrorMesage () {
      this.v$.$errors.forEach(element => {
        if (element.$property === 'username') {
          if (element.$validator === 'minLength') {
            this.validation.username.message = 'Username should be atleast 4 characters'
          } else if (element.$validator === 'maxLength') {
            this.validation.username.message = 'Username should not be more than 20 characters'
          } else if (element.$validator === 'required') {
            this.validation.username.message = 'Username is required'
          }
        }

        if (element.$property === 'pinCode') {
          if (element.$validator === 'minLength') {
            this.validation.pinCode.message = 'Pin Code should be atleast 6 characters'
          } else if (element.$validator === 'maxLength') {
            this.validation.pinCode.message = 'Pin Code should not be more than 6 characters'
          } else if (element.$validator === 'required') {
            this.validation.pinCode.message = 'Pin Code is required'
          } else if (element.$validator === 'numeric') {
            this.validation.pinCode.message = 'Security Key should be numeric'
          }
        }

        if (element.$property === 'email') {
            if (element.$validator === 'email') {
              this.validation.email.message = 'Invalid Email'
            } if (element.$validator === 'required') {
              this.validation.email.message = 'Email is required.'
            }
        }
      });
    }
  }
}
</script>
<style lang="scss">
.forgot-password-modal {
  .card-section {
    color: white;
    background-color: $backgroundHeader;
  }
  .card-content { 
    padding: 24px;
    background-color: $background;
    display: grid;
    grid-template-rows: 1fr;
    gap: 10px;

    .forgot-password-section {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
    }
    .forgot-password-action {
      background-color: #FFC108;
    }
    .q-field__control:before {
      border-color: white;
    }
    .q-input {
      color: white;
    }
  }
}
</style>